export var DomainStatusEnum;
(function (DomainStatusEnum) {
    DomainStatusEnum["PENDING"] = "pending";
    DomainStatusEnum["VERIFIED"] = "verified";
})(DomainStatusEnum || (DomainStatusEnum = {}));
export var DomainRouteTypeEnum;
(function (DomainRouteTypeEnum) {
    DomainRouteTypeEnum["AGENT"] = "agent";
    DomainRouteTypeEnum["WEBHOOK"] = "webhook";
})(DomainRouteTypeEnum || (DomainRouteTypeEnum = {}));
export var DomainDiagnosticCodeEnum;
(function (DomainDiagnosticCodeEnum) {
    DomainDiagnosticCodeEnum["MX_MISSING"] = "mx_missing";
    DomainDiagnosticCodeEnum["MX_WRONG_TARGET"] = "mx_wrong_target";
    DomainDiagnosticCodeEnum["MX_LOW_PRIORITY"] = "mx_low_priority";
    DomainDiagnosticCodeEnum["APEX_CNAME_COLLISION"] = "apex_cname_collision";
    DomainDiagnosticCodeEnum["DNSBL_LISTED"] = "dnsbl_listed";
})(DomainDiagnosticCodeEnum || (DomainDiagnosticCodeEnum = {}));
export var DomainDiagnosticCheckStatusEnum;
(function (DomainDiagnosticCheckStatusEnum) {
    DomainDiagnosticCheckStatusEnum["PASS"] = "pass";
    DomainDiagnosticCheckStatusEnum["FAIL"] = "fail";
    DomainDiagnosticCheckStatusEnum["SKIPPED"] = "skipped";
})(DomainDiagnosticCheckStatusEnum || (DomainDiagnosticCheckStatusEnum = {}));
export var DomainDiagnosticSeverityEnum;
(function (DomainDiagnosticSeverityEnum) {
    DomainDiagnosticSeverityEnum["WARN"] = "warn";
    DomainDiagnosticSeverityEnum["ERROR"] = "error";
})(DomainDiagnosticSeverityEnum || (DomainDiagnosticSeverityEnum = {}));
//# sourceMappingURL=domain.js.map